(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-section"] && !Shopify.designMode) return;
  try {
    
// Function to parse and render JSON content
function parseAndRenderContent(element) {
  const jsonString = element.getAttribute('data-content');
  if (!jsonString) return;
  
  try {
    const data = JSON.parse(jsonString);
    const html = renderJSONContent(data);
    element.innerHTML = html;
  } catch (e) {
    console.error('Error parsing JSON:', e);
    element.innerHTML = jsonString; // Fallback to raw content
  }
}

// Function to recursively render JSON content to HTML
function renderJSONContent(node) {
  if (!node || !node.type) return '';
  
  switch (node.type) {
    case 'root':
      return node.children ? node.children.map(child => renderJSONContent(child)).join('') : '';
      
    case 'paragraph':
      const pContent = node.children ? node.children.map(child => renderJSONContent(child)).join('') : '';
      return `<p>${pContent}</p>`;
      
    case 'text':
      const text = node.value || '';
      return node.bold ? `<strong>${text}</strong>` : text;
      
    case 'list':
      const listTag = node.listType === 'ordered' ? 'ol' : 'ul';
      const listItems = node.children ? node.children.map(child => renderJSONContent(child)).join('') : '';
      return `<${listTag}>${listItems}</${listTag}>`;
      
    case 'list-item':
      const liContent = node.children ? node.children.map(child => renderJSONContent(child)).join('') : '';
      return `<li>${liContent}</li>`;
      
    default:
      return '';
  }
}

// Parse all content on page load
document.querySelectorAll('.acc-content .inner[data-content]').forEach(element => {
  parseAndRenderContent(element);
});

// Accordion functionality
document.querySelectorAll('.acc-btn').forEach(button => {
  button.addEventListener('click', () => {
    const content = button.nextElementSibling;
    const icon = button.querySelector("span");
    const isActive = content.classList.contains('active');

    // Close all accordions
    document.querySelectorAll('.acc-content').forEach(c => {
      c.classList.remove('active');
      c.style.maxHeight = '0px';
    });

    document.querySelectorAll('.acc-btn span').forEach(i => {
      i.textContent = "+";
    });

    // Open clicked accordion if it was closed
    if (!isActive) {
      content.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 32 + "px";
      icon.textContent = "-";
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
